/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MeEventScoresResponse = {
    properties: {
        scores: {
    type: 'array',
    contains: {
        type: 'EmployeeEventScore',
    },
},
    },
};